import { IconButton } from '@civilgrid/ui/components';

interface Props {
  id: string;
}

export default function ({ id }: Props) {
  return (
    <IconButton
      icon="externalLink"
      variant="secondary"
      onClick={() => {
        const link = `${window.location.origin}/projects/${id}`;
        window.open(link, '_blank');
      }}
    >
      Open Project
    </IconButton>
  );
}
